import React, { ReactNode } from "react";
import classnames from "classnames";
import styles from "./Try.module.scss";

type Props = {
    children?: ReactNode;
}

const Try = (props: Props) => {
    const classes = classnames("lp-container try-it-container", styles["try-module"]);
    return (
        <div className={classes}>
          <div className="try-msg">
            <h2 className="into-line">Give TacBoard a try!</h2>

            <p>First, text a photo and/or message to:</p>
            <a href="sms:1-440-379-1306" className="phone-link">440-379-1306</a>

            <p>
              Then, <strong>on a computer, </strong><a href="http://tacb.io/bAv4V6aGhIVw?mode=live" target="_blank">Click here </a> to open a Live Photo Stream in a new window.
            </p>

            <p>
              Within seconds your photo will pop on the screen and join the rest of
              the photos in an endless loop of all-night excitement.
            </p>

            <h3>It's that easy!</h3>

            <p>
              You can also <a href="http://tacb.io/bAv4V6aGhIVw">view the full gallery here.</a>
            </p>

            {props.children}
          </div>
          <img src="/img/love-tree.svg" className={styles["love-tree"]} />
        </div>
    );
};

export default Try;
